import { StateCreator } from 'zustand';
import { Store } from '../index';

export interface NotificationFilterSlice {
  title: string | null;
  setTitle: (value: string | null) => void;

  apartmentComplexIds: number[];
  setApartmentComplexIds: (value: number[]) => void;

  wallMaterials: number[];
  setWallMaterials: (wallMaterials: number[]) => void;

  facilityTypeIds: number[];
  setFacilityTypeIds: (facilityTypeIds: number[]) => void;

  bedroomCount: number[];
  setBedroomCount: (bedroomCount: number[]) => void;

  priceTo: number | null;
  setPriceTo: (value: number | null) => void;

  priceFrom: number | null;
  setPriceFrom: (value: number | null) => void;

  areaTo: number | null;
  setAreaTo: (value: number | null) => void;

  areaFrom: number | null;
  setAreaFrom: (value: number | null) => void;

  pricePerSqMTo: number | null;
  setPricePerSqMTo: (value: number | null) => void;

  pricePerSqMFrom: number | null;
  setPricePerSqMFrom: (value: number | null) => void;

  commissioningYearFrom: number | null;
  setCommissioningYearFrom: (value: number) => void;

  commissioningYearTo: number | null;
  setCommissioningYearTo: (value: number) => void;

  floorFrom: number | null;
  setFloorFrom: (value: number) => void;

  floorTo: number | null;
  setFloorTo: (value: number) => void;

  floorCountFrom: number | null;
  setFloorCountFrom: (value: number) => void;

  floorCountTo: number | null;
  setFloorCountTo: (value: number) => void;

  clearFilterForm: () => void;

  marketPriceFrom: null;
  marketPriceTo: null;
  buildingIds: [];
  isCommissioned: null;
  balconyCount: [];
}

const createNotificationFilterSlice: StateCreator<
  Store,
  [['zustand/immer', never]],
  [],
  NotificationFilterSlice
> = (set) => ({
  title: null,
  setTitle: (title: string | null) => set({ title }),

  apartmentComplexIds: [],
  setApartmentComplexIds: (apartmentComplexIds: number[]) => {
    set((state) => {
      state.apartmentComplexIds = [...apartmentComplexIds];
    });
  },

  wallMaterials: [],
  setWallMaterials: (wallMaterials: number[]) => {
    set((state) => {
      state.wallMaterials = [...wallMaterials];
    });
  },

  facilityTypeIds: [],
  setFacilityTypeIds: (facilityTypeId: number[]) => {
    set((state) => {
      state.facilityTypeIds = [...facilityTypeId];
    });
  },

  bedroomCount: [],
  setBedroomCount: (bedroom: number[]) => {
    set((state) => {
      state.bedroomCount = [...bedroom];
    });
  },

  priceTo: null,
  setPriceTo: (value: number | null) => set({ priceTo: value }),

  priceFrom: null,
  setPriceFrom: (value: number | null) => set({ priceFrom: value }),

  areaTo: null,
  setAreaTo: (value: number | null) => set({ areaTo: value }),

  areaFrom: null,
  setAreaFrom: (value: number | null) => set({ areaFrom: value }),

  pricePerSqMTo: null,
  setPricePerSqMTo: (value: number | null) => set({ pricePerSqMTo: value }),

  pricePerSqMFrom: null,
  setPricePerSqMFrom: (value: number | null) => set({ pricePerSqMFrom: value }),

  commissioningYearFrom: null,
  setCommissioningYearFrom: (value: number | null) => set({ commissioningYearFrom: value }),

  commissioningYearTo: null,
  setCommissioningYearTo: (value: number | null) => set({ commissioningYearTo: value }),

  floorFrom: null,
  setFloorFrom: (value: number | null) => set({ floorFrom: value }),

  floorTo: null,
  setFloorTo: (value: number | null) => set({ floorTo: value }),

  floorCountFrom: null,
  setFloorCountFrom: (value: number | null) => set({ floorCountFrom: value }),

  floorCountTo: null,
  setFloorCountTo: (value: number | null) => set({ floorCountTo: value }),

  clearFilterForm: () => {
    set({
      title: null,
      apartmentComplexIds: [],
      wallMaterials: [],
      facilityTypeIds: [],
      bedroomCount: [],
      priceTo: null,
      priceFrom: null,
      areaTo: null,
      areaFrom: null,
      pricePerSqMTo: null,
      pricePerSqMFrom: null,
      commissioningYearFrom: null,
      commissioningYearTo: null,
      floorFrom: null,
      floorTo: null,
      floorCountFrom: null,
      floorCountTo: null,
    });
  },

  marketPriceFrom: null,
  marketPriceTo: null,
  buildingIds: [],
  isCommissioned: null,
  balconyCount: [],
});

export default createNotificationFilterSlice;
